import computeSuperBoundaryBox from '../helpers/super-boundary-box'
import { mapState } from 'vuex'

export const mapBoundariesMixin = {
  computed: {
    ...mapState(['searchedLocation']),

    pointsLatitudes() {
      return this.points.map(p => p.lat)
    },

    pointsLongitudes() {
      return this.points.map(p => p.lon)
    },

    pointsBoundaries() {
      if (this.points.length) {
        return {
          minLatitude: Math.min(...this.pointsLatitudes),
          maxLatitude: Math.max(...this.pointsLatitudes),
          minLongitude: Math.min(...this.pointsLongitudes),
          maxLongitude: Math.max(...this.pointsLongitudes)
        }
      }
      return null
    },

    mapBoundaries() {
      if (this.searchedLocation) {
        // Our search radius is in km, but maplibre can only accept map bounds in lat/lon degrees.
        // Rather than do expensive calculations to find the coordinates for a 50km circle, we just
        // use 0.5 degrees as a rough proxy.
        return {
          minLatitude: this.searchedLocation.latitude - 0.5,
          maxLatitude: this.searchedLocation.latitude + 0.5,
          minLongitude: this.searchedLocation.longitude - 0.5,
          maxLongitude: this.searchedLocation.longitude + 0.5
        }
      }
      else if (this.filteredBoundaries) {
        return transformBoundaryKeysSnakeToCamel(this.filteredBoundaries)
      }
      else {
        let organisationBoundariesRenamed = null
        if (this.organisationBoundaries) {
          organisationBoundariesRenamed = transformBoundaryKeysSnakeToCamel(this.organisationBoundaries)
        }
        return computeSuperBoundaryBox(this.pointsBoundaries, organisationBoundariesRenamed)
      }
    }
  }
}

function transformBoundaryKeysSnakeToCamel(boundaries) {
  const {min_latitude: minLatitude, max_latitude: maxLatitude, min_longitude: minLongitude, max_longitude: maxLongitude} = boundaries
  return {
    minLatitude, maxLatitude, minLongitude, maxLongitude
  }
}
